import type {ValueOf} from '~/types/value-of'

export type Column = {
  name: string
  field: string
  isToggleColumn?: boolean
  unit?: string
  isHoverable?: boolean
  tooltip?: string
}

export const sortDirectionType = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const
export type sortDirectionType = ValueOf<typeof sortDirectionType>